module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Stairs-a73abe616559de3b34a69798ae7824e2.svg";